import cn from "classnames";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Format } from "../constants/formats";
import styles from "./FormatButton.module.css";

import formatCloseupPosterLarge from "../assets/images/format-closeup_poster_large.svg";
import formatCloseupPosterMedium from "../assets/images/format-closeup_poster_medium.svg";
import formatLarge from "../assets/images/format-large.svg";
import formatMedium from "../assets/images/format-medium.svg";
import formatPanoramaPosterLarge from "../assets/images/format-panorama_poster_large.svg";
import formatPanoramaPosterMedium from "../assets/images/format-panorama_poster_medium.svg";
import formatRoundLarge from "../assets/images/format-round_large.svg";
import formatRoundMedium from "../assets/images/format-round_medium.svg";
import formatSmall from "../assets/images/format-small.svg";

const icons = {
  small: formatSmall,
  medium: formatMedium,
  large: formatLarge,
  round_medium: formatRoundMedium,
  round_large: formatRoundLarge,
  panorama_poster_medium: formatPanoramaPosterMedium,
  panorama_poster_large: formatPanoramaPosterLarge,
  closeup_poster_medium: formatCloseupPosterMedium,
  closeup_poster_large: formatCloseupPosterLarge,
};

const formatter = Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

interface Props {
  id: string;
  format: Format;
  selected: boolean;
  disabled?: boolean;
  onSelect: (format: string) => void;
}

export const FormatButton: FunctionComponent<Props> = ({
  id,
  format,
  selected,
  disabled = false,
  onSelect,
}) => {
  const { t } = useTranslation();
  return (
    <a
      className={cn([
        styles.container,
        selected && styles.containerSelected,
        disabled && styles.containerDisabled,
      ])}
      onClick={(e) => {
        e.preventDefault();
        if (disabled) return;
        onSelect(id);
      }}
      title={disabled ? undefined : t(`size_title--${id.toLowerCase()}`)}
      aria-disabled={disabled}
    >
      <img
        className={styles.image}
        src={icons[id.toLowerCase()].src}
        height="100"
        alt={t(`size_title--${id.toLowerCase()}`)}
      />

      <div className={styles.size}>
        {format.round
          ? `⌀${format.displayWidth}cm`
          : `${format.displayWidth}cm × ${format.displayHeight}cm`}
      </div>

      <div className={styles.price}>{formatter.format(format.price)}</div>

      {disabled && (
        <span className={styles.tooltip} role="tooltip">
          {t("size_disabled_tooltip")}
        </span>
      )}
    </a>
  );
};
